import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { PortalSidebar } from "@/components/PortalSidebar";
import { PortalHeader } from "@/components/PortalHeader";
import { SidebarTab } from "@/components/SidebarTab";
import { Loader2 } from "lucide-react";

interface PortalLayoutProps {
  children: ReactNode;
}

export const PortalLayout = ({ children }: PortalLayoutProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <SidebarProvider>
      <div className="min-h-screen flex flex-col w-full bg-background overflow-x-clip">
        <PortalHeader />
        <div className="flex flex-1 w-full min-h-0">
          <PortalSidebar />
          <SidebarTab />
          <div className="flex-1 flex flex-col min-w-0">
            <main className="flex-1 p-3 sm:p-6 min-w-0">
              {children}
            </main>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};
